import authentication from '../middleware/authentication'
const AgentList = () => import(/* webpackChunkName: "static/js/chunks/AgentList" */'../../views/agent/AgentList')
const agentRoutes = {
  path: '/agents',
  name: 'AgentList',
  component: AgentList,
  meta: {
    middleware: authentication,
    layout: 'main'
  }
}

export default agentRoutes
